const Preloader = () => {
  const normalizedData = {

  }

  return normalizedData
}

export default Preloader
